export const ohipRegions = [
  // United States
  {
    value: 'us-ashburn-1',
    label: 'US East (Ashburn, Virginia)',
    group: 'United States'
  },
  {
    value: 'us-phoenix-1',
    label: 'US West (Phoenix, Arizona)',
    group: 'United States'
  },
  {
    value: 'us-chicago-1',
    label: 'US Midwest (Chicago, Illinois)',
    group: 'United States'
  },
  {
    value: 'us-sanjose-1',
    label: 'US West (San Jose, California)',
    group: 'United States'
  },

  // Europe
  {
    value: 'eu-frankfurt-1',
    label: 'Frankfurt, Germany',
    group: 'Europe'
  },
  {
    value: 'eu-amsterdam-1',
    label: 'Amsterdam, Netherlands',
    group: 'Europe'
  },
  {
    value: 'eu-zurich-1',
    label: 'Zurich, Switzerland',
    group: 'Europe'
  },
  {
    value: 'uk-london-1',
    label: 'London, United Kingdom',
    group: 'Europe'
  },
  {
    value: 'eu-paris-1',
    label: 'Paris, France',
    group: 'Europe'
  },
  {
    value: 'eu-marseille-1',
    label: 'Marseille, France',
    group: 'Europe'
  },
  {
    value: 'eu-milan-1',
    label: 'Milan, Italy',
    group: 'Europe'
  },
  {
    value: 'eu-stockholm-1',
    label: 'Stockholm, Sweden',
    group: 'Europe'
  },
  {
    value: 'eu-madrid-1',
    label: 'Madrid, Spain',
    group: 'Europe'
  },

  // Asia Pacific
  {
    value: 'ap-sydney-1',
    label: 'Sydney, Australia',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-melbourne-1',
    label: 'Melbourne, Australia',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-tokyo-1',
    label: 'Tokyo, Japan',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-osaka-1',
    label: 'Osaka, Japan',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-singapore-1',
    label: 'Singapore',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-mumbai-1',
    label: 'Mumbai, India',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-hyderabad-1',
    label: 'Hyderabad, India',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-seoul-1',
    label: 'Seoul, South Korea',
    group: 'Asia Pacific'
  },
  {
    value: 'ap-chuncheon-1',
    label: 'Chuncheon, South Korea',
    group: 'Asia Pacific'
  },

  // Canada
  {
    value: 'ca-toronto-1',
    label: 'Toronto, Ontario',
    group: 'Canada'
  },
  {
    value: 'ca-montreal-1',
    label: 'Montreal, Quebec',
    group: 'Canada'
  },

  // Latin America
  {
    value: 'sa-saopaulo-1',
    label: 'São Paulo, Brazil',
    group: 'Latin America'
  },
  {
    value: 'sa-vinhedo-1',
    label: 'Vinhedo, Brazil',
    group: 'Latin America'
  },
  {
    value: 'sa-santiago-1',
    label: 'Santiago, Chile',
    group: 'Latin America'
  },
  {
    value: 'mx-queretaro-1',
    label: 'Querétaro, Mexico',
    group: 'Latin America'
  },

  // Middle East & Africa
  {
    value: 'me-jeddah-1',
    label: 'Jeddah, Saudi Arabia',
    group: 'Middle East & Africa'
  },
  {
    value: 'me-dubai-1',
    label: 'Dubai, UAE',
    group: 'Middle East & Africa'
  },
  {
    value: 'il-jerusalem-1',
    label: 'Jerusalem, Israel',
    group: 'Middle East & Africa'
  },
  {
    value: 'af-johannesburg-1',
    label: 'Johannesburg, South Africa',
    group: 'Middle East & Africa'
  }
]
